import { Nav } from "react-bootstrap";
import CompanyDashboard from "../../organisms/CompanyDashboard";
import ReportManagement from "../../organisms/ReportManagement";
import { useNavigate, useParams } from "react-router-dom";
import BranchMemo from "../../organisms/BranchMemo";
import React from "react";
import { useSelector } from "react-redux";
import AccessDenied from "../AuthPage/AccessDenied";
import Settlement from "../../organisms/Settlement";
import SettlementCount from "../../organisms/SettlementCount";

const CompanyMain = React.memo(() => {
    const { type, companyId, branchId } = useParams();
    const navigate = useNavigate();
    const locationInfo = useSelector(state => state.location);
    const loginInfo = useSelector(state => state.login);

    if (branchId == '0' && loginInfo.admin.level > 2) {
        return <AccessDenied/>;
    }

    return (
        <>
            <div className="page-title">
                <span className="fw-bold">{locationInfo.company}</span> <span className="fw-normal">{locationInfo.branch}</span>
            </div>

            <Nav className="nav-tabs" activeKey={type + "/" + companyId + "/" + branchId}
            onSelect={(activeKey) => {
                navigate("../"+activeKey)
            }}>
                <Nav.Item>
                    <Nav.Link eventKey={`dashboard/${companyId}/${branchId}`}>
                        대시보드
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey={`reportManagement/${companyId}/${branchId}`}>리포트 관리</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey={`settlement/${companyId}/${branchId}`}>피부측정</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey={`settlementCount/${companyId}/${branchId}`}>정산</Nav.Link>
                </Nav.Item>
                {
                    branchId !== "0" &&
                    <Nav.Item>
                        <Nav.Link eventKey={`branchMemo/${companyId}/${branchId}`} title={`reportManagement/${companyId}/${branchId}`} onClick={() => {
                        }}>지점 메모</Nav.Link>
                    </Nav.Item>
                }
            </Nav>

            {
                type == "dashboard" &&
                <CompanyDashboard />
            }
            {
                type == "reportManagement" &&
                <ReportManagement />
            }
            {
                type == "branchMemo" &&
                <BranchMemo />
            }
            {
                type == "settlement" &&
                <Settlement />
            }
            {
                type == "settlementCount" &&
                <SettlementCount />
            }
        </>
    );
})

export default CompanyMain;
